import React, { createContext, useContext, useState } from "react";
import { setCompanyId, clearCompanyId } from "../config/appConfig";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [companyId, setCompanyIdState] = useState(
    () => localStorage.getItem("companyId") || null
  );
  const [company, setCompany] = useState(() => {
    const stored = localStorage.getItem("company");
    return stored ? JSON.parse(stored) : null;
  });
  const [memberEmail, setMemberEmailState] = useState(
    () => localStorage.getItem("memberEmail") || null
  );

  // サインイン後に呼ぶ: companyId と company オブジェクトを保存
  const login = (id, companyData, email) => {
    setCompanyId(id); // appConfig の live binding を更新
    setCompanyIdState(id);
    setCompany(companyData);
    localStorage.setItem("company", JSON.stringify(companyData));
    if (email) {
      setMemberEmailState(email);
      localStorage.setItem("memberEmail", email);
    }
  };

  // ログアウト: すべてクリア
  const logout = () => {
    clearCompanyId(); // appConfig の live binding をクリア
    setCompanyIdState(null);
    setCompany(null);
    setMemberEmailState(null);
    localStorage.removeItem("company");
    localStorage.removeItem("memberEmail");
  };

  return (
    <AuthContext.Provider
      value={{
        companyId,
        company,
        memberEmail,
        isAuthenticated: !!companyId,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
